export default "__VITE_ASSET__b494edeb__"